export class CarOperationsEntity {
  userId;
  carId;
  SiteId;
  carEntity;
  carTokens;

  constructor(carId, userId, SiteId, carEntity = null, carTokens = null) {
    this.carId = carId;
    this.userId = userId;
    this.SiteId = SiteId;
    this.carEntity = carEntity;
    this.carTokens = carTokens;
  }
}
